export const commonTextData = {
  logoText: {
    en: 'Creative MindFulness',
    it: 'Mente creativa',
    es: 'Mindfulness Creativo',
    pl: 'Inteligencja twórcza ',
    de: 'Kreative Achtsamkeit',
    fr: 'Pleine conscience créative',
    cz: 'Kreativní všímavost',
  },
  goToStore: {
    en: 'Go to store',
    it: 'Vai al negozio',
    es: 'Ir a la tienda',
    pl: 'Przejdź do sklepu',
    de: 'Zum Shop gehen',
    fr: 'Aller à la boutique',
    cz: 'Přejít do obchodu',
  },
  chooseCountry: {
    en: 'CHOOSE YOUR COUNTRY',
    it: 'SCEGLI IL TUO PAESE',
    es: 'ELIGE TU PAÍS',
    pl: 'WYBIERZ SWÓJ KRAJ',
    de: 'WÄHLE DEIN LAND',
    fr: 'CHOISISSEZ VOTRE PAYS',
    cz: 'VYBERTE SI ZEMI',
  },
  buttonPoland: {
    en: 'Poland',
    it: 'Polonia',
    es: 'Polonia',
    pl: 'Polska',
    de: 'Polen',
    fr: 'Pologne',
    cz: 'Polsko',
  },
  buttonOtherCountries: {
    en: 'Other countries',
    it: 'Altri paesi',
    es: 'Otros países',
    pl: 'Inne Państwa',
    de: 'Andere Länder',
    fr: 'Autres pays',
    cz: 'Ostatní země',
  },
  chooseBoardTitle: {
    en: 'Choose your board',
    it: 'Scegli la tua tavola',
    es: 'Elige tu tablero',
    pl: 'Wybierz swoją płytę',
    de: 'Wähle dein Brett',
    fr: 'Choisis ta planche',
    cz: 'Vyber svou desku',
  },
  chooseBoardPageDescription: {
    en: 'You can choose only one option. A white or black board',
    it: `Puoi scegliere solo un'opzione. Tavola bianca o nera`,
    es: 'Elige solo una opción. Tablero blanco o negro',
    pl: 'Wybierz jedną opcję: biała lub czarna płyta.',
    de: 'Wähle nur eine Option. Weißes oder schwarzes Brett',
    fr: 'Choisis une seule option. Une planche blanche ou noire',
    cz: 'Vyber pouze jednu možnost. Bílou nebo černou desku',
  },
  whiteBoard: {
    en: 'White board',
    it: 'Tavola bianca',
    es: 'Tablero blanco',
    pl: 'Biała płyta',
    de: 'Weißes Brett',
    fr: 'Planche blanche',
    cz: 'Bílá deska',
  },
  blackBoard: {
    en: 'Black board',
    it: 'Tavola nera',
    es: 'Tablero negro',
    pl: 'Czarna płyta',
    de: 'Schwarzes Brett',
    fr: 'Planche noire',
    cz: 'Černá deska',
  },
  uploadPhotoButtonHomePage: {
    en: 'Upload a photo',
    it: 'Carica una foto',
    es: 'Subir foto',
    pl: 'Prześlij zdjęcie',
    de: 'Foto hochladen',
    fr: 'Télécharger une photo',
    cz: 'Nahrát fotografii',
  },
  chooseDesignsButtonHomePage: {
    en: 'Choose designs',
    it: 'Scegli i disegni',
    es: 'Elige diseños',
    pl: 'Wybierz projekty',
    de: 'Designs auswählen',
    fr: 'Choisir un modèle',
    cz: 'Vybrat návrhy',
  },
  contactUs: {
    en: `Contact us: `,
    it: `Contattaci: `,
    es: `Ponte en contacto con nosotros: `,
    pl: `Skontaktuj się z nami: `,
    de: `Kontaktiere uns: `,
    fr: `Contactez-nous : `,
    cz: `Kontaktujte nás: `,
  },
  contactEmail: {
    en: 'support@letsstring.store',
    it: 'support@letsstring.store',
    es: 'support@letsstring.store',
    pl: 'support@letsstring.store',
    de: 'support@letsstring.store',
    fr: 'support@letsstring.store',
    cz: 'support@letsstring.store',
  },
  verifyCouponPageTitle: {
    en: "Enter the ‘Let's String’ code provided in your kit",
    it: `Inserisci codice "Let's String" fornito nel kit`,
    es: `Introduce el código "Let's String" que se incluye en tu kit`,
    pl: `Wprowadź kod "Let's String" dostarczony w zestawie.`,
    de: `Gib den 'Let's String-Code aus deinem Kit ein`,
    fr: `Entrez le code 'Let's String' fourni dans votre kit`,
    cz: `Zadejte kód 'Let's String' z vašeho balíčku`,
  },
  buttonBack: {
    en: 'Back',
    it: `Indietro`,
    es: `Volver`,
    pl: `Powrót`,
    de: `Zurück`,
    fr: `Retour`,
    cz: `Zpět`,
  },
  buttonFurther: {
    en: 'Next',
    it: `Avanti `,
    es: `Más`,
    pl: `Dalej`,
    de: `Weiter`,
    fr: `Suivant`,
    cz: `Další`,
  },
  verifyError: {
    en: "We couldn't find the code you entered. Please double-check and ensure that you haven't mistakenly used the letter 'i' instead of the number '1'. Please note that the code should only consist of Latin letters and numbers.",
    it: `Non siamo riusciti a trovare il codice inserito. Si prega di ricontrollare
    e di assicurarsi di non aver erroneamente utilizzato la lettera "i" al posto del numero "1". Il codice deve essere composto solo da lettere
    e numeri latini.`,
    es: `No hemos encontrado el código que has introducido. Por favor, compruebe que no ha utilizado por error la letra "i" en lugar del número "1". Tenga en cuenta que el código sólo debe constar de letras y números latinos.`,
    pl: `Nie mogliśmy znaleźć wprowadzonego kodu. Upewnij się, że przez pomyłkę nie użyłeś litery "i" zamiast cyfry "1". Należy pamiętać, że kod powinien składać się wyłącznie z liter alfabetu łacińskiego i cyfr.`,
    de: `Wir konnten den eingegebenen Code nicht finden. Bitte überprüfen Sie, ob Sie versehentlich den Buchstaben 'i' anstelle der Zahl '1' verwendet haben. Beachten Sie, dass der Code nur aus lateinischen Buchstaben und Zahlen bestehen sollte.`,
    fr: `Nous n'avons pas trouvé le code que vous avez saisi. Veuillez vérifier que vous n'avez pas utilisé par erreur la lettre 'i' au lieu du chiffre '1'. Notez que le code ne doit contenir que des lettres et des chiffres latins.`,
    cz: `Zadaný kód jsme nenašli. Zkontrolujte prosím, zda jste omylem nepoužili písmeno 'i' místo číslice '1'. Kód by měl obsahovat pouze latinská písmena a číslice.`,
  },
  requiredCode: {
    en: 'Code is required',
    it: `Il codice è obbligatorio`,
    es: `Se requiere código`,
    pl: `Kod jest wymagany`,
    de: `Code ist erforderlich`,
    fr: `Le code est requis`,
    cz: `Kód je povinny`,
  },
  invalidCode: {
    en: 'Code has invalid format',
    it: `Il codice ha un formato non valido`,
    es: `El código tiene un formato no válido`,
    pl: `Kod ma nieprawidłowy format`,
    de: `Ungültiges Code-Format`,
    fr: `Format de code invalide`,
    cz: `Neplatný formát kódu`,
  },
  showReadyArtTitle: {
    en: 'Click "further" to continue',
    it: `Fare clic su «Più avanti» per continuare`,
    es: `Haga clic en «Más información» para continuar`,
    pl: `Naciśnij «Dalej», aby kontynuować`,
    de: `Klicken Sie auf "Weiter" um fortzufahren`,
    fr: `Cliquez sur "Suivant" pour continuer`,
    cz: `Pokračujte kliknutím na „Další“`,
  },
  uploadPageTitle: {
    en: 'The file size should not exceed 15 MB',
    it: `La dimensione del file non deve superare i 15 MB`,
    es: `El tamaño del archivo no debe superar los 15 MB`,
    pl: `Rozmiar pliku nie może przekraczać 15 MB`,
    de: `Die Dateigröße sollte 15 MB nicht überschreiten`,
    fr: `La taille du fichier ne doit pas dépasser 15 MB`,
    cz: `Velikost souboru by neměla přesáhnout 15 MB`,
  },
  uploadButton: {
    en: 'Upload a photo',
    it: `Carica una foto`,
    es: `Suba una foto`,
    pl: `Prześlij zdjęcie`,
    de: `Foto hochladen`,
    fr: `Télécharger une photo`,
    cz: `Nahrát fotografii`,
  },
  cropPageTitle: {
    en: 'Please adjust the image',
    it: `Si prega di regolare l'immagine`,
    es: `Ajusta la imagen`,
    pl: `Prosimy o przygotowanie zdjęcia`,
    de: `Bitte passen Sie das Bild an`,
    fr: `Veuillez ajuster l'image`,
    cz: `Upravte prosím obrázek`,
  },
  generateArtPageTitle: {
    en: 'Please stay on this page without closing your browser. The loading will take up to 5-10 minutes',
    it: `Rimani su questa pagina senza chiudere il browser. Il caricamento richiederà fino a 5-10 minuti`,
    es: `Permanezca en esta página sin cerrar su navegador. La carga tardará entre 5 y 10 minutos`,
    pl: `Proszę pozostać na tej stronie, nie zamykając przeglądarki. Ładowanie może potrwać od 5 do 10 minut`,
    de: `Bitte bleib auf dieser Seite und schließe deinen Browser nicht. Das Laden kann bis zu 5-10 Minuten dauern`,
    fr: `Veuillez rester sur cette page sans fermer votre navigateur. Le chargement prendra jusqu'à 5 à 10 minutes`,
    cz: `Zůstaňte prosím na této stránce a nezavírejte prohlížeč. Načítání může trvat 5 až 10 minut`,
  },
  differentImageTitle: {
    en: 'You can try a different image if you’re not happy with the current result',
    it: `Puoi provare un'altra immagine se il risultato attuale non ti soddisfa`,
    es: `Puedes probar con otra imagen si el resultado actual no te convence`,
    pl: `Możesz spróbować innego zdjęcia, jeśli obecny wynik Ci się nie podoba`,
    de: `Du kannst ein anderes Bild ausprobieren, wenn dir das aktuelle Ergebnis nicht gefällt`,
    fr: `Vous pouvez essayer une autre image si le résultat actuel ne vous plaît pas`,
    cz: `Můžeš zkusit jiný obrázek, pokud se ti aktuální výsledek nelíbí`,
  },
  enterEmailPageTitle: {
    en: 'Congratulations! Your instructions are ready! Please, enter your email address and we will immediately send instructions for assembly',
    it: `Congratulazioni! Le istruzioni sono pronte! Inserite il vostro indirizzo e-mail e vi invieremo immediatamente le istruzioni per il montaggio.`,
    es: `¡Enhorabuena! ¡Sus instrucciones están listas! Por favor, introduzca su dirección de correo electrónico y le enviaremos inmediatamente las instrucciones de montaje`,
    pl: `Gratulacje! Twoja instrukcja jest gotowa! Wprowadź swoj adres e-mail a my natychmiast wyślemy instrukcje montażu`,
    de: `Herzlichen Glückwunsch! Deine Anleitung ist jetzt bereit! Bitte gib deine E-Mail-Adresse ein, und wir senden dir sofort die Montageanleitung zu`,
    fr: `Félicitations ! Vos instructions sont prêtes ! Veuillez entrer votre adresse e-mail et nous vous enverrons immédiatement les instructions de montage`,
    cz: `Gratulujeme! Vaše instrukce jsou připraveny! Zadejte prosím svou e-mailovou adresu a my vám instrukce okamžitě zašleme.`,
  },
  attentionText: {
    en: 'Pay attention! Assembly instructions can be sent to the mail no more than 3 times. Then the code will be inactive',
    it: `Attenzione! Le istruzioni di montaggio possono essere inviate per posta non più di 3 volte. In tal caso il codice non sarà più attivo`,
    es: `¡Atención! Las instrucciones de ensamblaje pueden enviarse al correo no más de 3 veces. Luego, el código estará inactivo`,
    pl: `Uwaga! Instrukcja montażu może zostać wysłana na adres e-mail nie więcej niż 3 razy. Następnie kod będzie nieaktywny`,
    de: `Achtung! Die Montageanleitung kann maximal 3 Mal per E-Mail versendet werden. Danach wird der Code inaktiv`,
    fr: `Attention ! Les instructions de montage peuvent être envoyées par e-mail au maximum 3 fois. Ensuite, le code sera inactif`,
    cz: `Pozor! Instrukce lze zaslat e-mailem maximálně 3krát. Poté bude kód neaktivní.`,
  },
  additionalText: {
    en: 'By clicking on the "Send" button, I give my permission to process my personal data for the purpose of informing me about special offers and prices. I can revoke this consent at any time by writing to support@letsstring.store.',
    it: `Facendo clic sul pulsante "Invia", do il mio consenso al trattamento dei miei dati personali allo scopo di informarmi su offerte e prezzi speciali. Posso revocare questo consenso in qualsiasi momento scrivendo a support@letsstring.store`,
    es: `Al hacer clic en el botón "Enviar", doy mi permiso para procesar mis datos personales con el fin de informarme sobre ofertas especiales y precios. Puedo revocar este consentimiento en cualquier momento escribiendo a support@letsstring.store.`,
    pl: `Klikając przycisk "Wyślij", wyrażam zgodę na przetwarzanie moich danych osobowych w celu informowania mnie o ofertach specjalnych i cenach. Mogę odwołać tę zgodę w dowolnym momencie, pisząc na adres support@letsstring.store.`,
    de: `Durch Klicken auf die Schaltfläche "Senden" erteile ich meine Zustimmung zur Verarbeitung meiner personenbezogenen Daten zum Zwecke der Information über Sonderangebote und Preise. Ich kann diese Zustimmung jederzeit widerrufen, indem ich an support@letsstring.store schreibe.`,
    fr: `En cliquant sur le bouton "Envoyer", je donne mon accord pour le traitement de mes données personnelles afin d'être informé des offres spéciales et des prix. Je peux révoquer ce consentement à tout moment en écrivant à support@letsstring.store.`,
    cz: `Kliknutím na tlačítko "Odeslat" dávám souhlas se zpracováním svých osobních údajů za účelem informování o speciálních nabídkách a cenách. Tento souhlas mohu kdykoli odvolat napsáním na support@letsstring.store.`,
  },
  sendButton: {
    en: 'Send',
    it: `Invia`,
    es: `Enviar`,
    pl: `Wysłać`,
    de: `Senden`,
    fr: `Envoyer`,
    cz: `Odeslat`,
  },
  enterEmailError: {
    en: 'Please enter a valid e-mail',
    it: 'Inserisci una email valida',
    es: 'Por favor introduzca una dirección de correo electrónico válida',
    pl: 'Proszę podać poprawny adres e-mail',
    de: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    fr: 'Veuillez entrer une adresse e-mail valide',
    cz: 'Zadejte prosím platnou e-mailovou adresu',
  },
  requiredEmail: {
    en: 'Email is required',
    it: "L'e-mail è obbligatoria",
    es: 'correo electronico es requerido',
    pl: 'Email jest wymagany',
    de: 'E-Mail ist erforderlich',
    fr: `L'e-mail est requis`,
    cz: 'E-mail je povinný',
  },
  confirmEmailPageTitle: {
    en: 'Please check your Email',
    it: "Controlla l'e-mail",
    es: 'Compruebe su dirección de correo electrónico',
    pl: 'Sprawdź swój adres e-mail',
    de: 'Bitte überprüfe deine E-Mail',
    fr: 'Merci de vérifier votre adresse e-mail',
    cz: 'Zkontrolujte prosím svůj e-mail',
  },
  confirmEmailText: {
    en: 'Is this email correct?',
    it: "L'e-mail è corretta?",
    es: '¿Es correcto este correo electrónico?',
    pl: 'Czy ten adres e-mail jest prawidłowy?',
    de: 'Ist diese E-Mail korrekt?',
    fr: 'Cet e-mail est-il correct ?',
    cz: 'Je tento e-mail správný?',
  },
  yesButton: {
    en: 'Yes',
    it: 'Sì',
    es: 'Sí',
    pl: 'Tak',
    de: 'Ja',
    fr: 'Oui',
    cz: 'Ano',
  },
  noButton: {
    en: 'No',
    it: 'No',
    es: 'No',
    pl: 'Nie',
    de: 'Nein',
    fr: 'Non',
    cz: 'Ne',
  },
  finalPageTitle: {
    en: 'Your instructions for printing and for online assembly are in your Email',
    it: 'Le istruzioni per la stampa e per il montaggio online sono nella vostra e-mail',
    es: 'Sus instrucciones para la impresión y el montaje en línea se encuentran en su correo electrónico',
    pl: 'Instrukcje dotyczące drukowania i montażu online znajdują się w wiadomości e-mail',
    de: 'Deine Anleitungen zum Drucken und zur Online-Montage befinden sich in deinem Posteingang',
    fr: `Les instructions pour l'impression et l'assemblage en ligne ont été envoyées à votre adresse e-mail`,
    cz: 'Vaše pokyny pro tisk a online montáž jsou ve vašem e-mailu',
  },
  finalPageText: {
    en: 'You can now join the journey to Creative Mindfulness 🌱',
    it: 'Ora potete unirvi al viaggio verso la Mindfulness creativa 🌱',
    es: 'Ya puedes unirte al viaje hacia Atención Plena Creativa 🌱',
    pl: 'Teraz możesz dołączyć do podróży w kreatywność opartą na uważności 🌱',
    de: 'Du kannst jetzt deine Reise zur kreativen Achtsamkeit beginnen 🌱',
    fr: 'Vous pouvez maintenant commencer votre voyage vers la pleine conscience créative 🌱',
    cz: 'Nyní se můžete vydat na cestu ke kreativní všímavosti 🌱',
  },
  startAssemblyButton: {
    en: 'Start assembly online',
    it: "Iniziare l'assemblaggio online",
    es: 'Iniciar el montaje en línea',
    pl: 'Rozpocznij montaż online',
    de: 'Online-Montage starten',
    fr: 'Lancer l’assemblage en ligne',
    cz: 'Spustit online montáž',
  },
  downloadPDFButton: {
    en: 'Download PDF-instruction',
    it: 'Scarica le istruzioni in PDF',
    es: 'Descargar instrucciones en PDF',
    pl: 'Pobierz instrukcję w formacie PDF',
    de: 'PDF-Anleitung herunterladen',
    fr: 'Télécharger les instructions PDF',
    cz: 'Stáhnout PDF návod',
  },
  goToMainPageButton: {
    en: 'Main page',
    it: 'Pagina principale',
    es: 'Página principal',
    pl: 'Strona główna',
    de: 'Hauptseite',
    fr: 'Page principale',
    cz: 'Hlavní stránka',
  },
  chooseButton: {
    en: 'Choose',
    it: 'Scegliere',
    es: 'Elegir',
    pl: 'Wybierz',
    de: 'Auswählen',
    fr: 'Sélectionner',
    cz: 'Vybrat',
  },
  readyDesignsText: {
    en: " If you're not sure which photo to use, you can choose one from the images we've carefully prepared for you",
    it: 'Se non siete sicuri di quale foto usare, potete sceglierne una tra le immagini che abbiamo preparato con cura per voi.',
    es: 'Si no estás seguro(a) de qué foto escoger, puedes elegir una de las imágenes que hemos preparado cuidadosamente para ti.',
    pl: 'Jeśli nie masz pewności, które zdjęcie wybrać, możesz skorzystać z jednego z obrazów, które starannie dla Ciebie przygotowaliśmy.',
    de: 'Wenn du dir nicht sicher bist, welches Foto du verwenden sollst, kannst du eines aus den Bildern auswählen, die wir sorgfältig für dich vorbereitet haben.',
    fr: "Si vous n'êtes pas sûr de la photo à utiliser, vous pouvez en choisir une parmi les images que nous avons soigneusement préparées pour vous",
    cz: `Pokud si nejste jisti, kterou fotografii použít, můžete si vybrat jednu z obrázků, které jsme pro vás pečlivě připravili`,
  },
  lostButton: {
    en: "I'm lost",
    it: 'Mi sono persə',
    es: 'Estoy perdido',
    pl: 'Zgubiłem się',
    de: 'Ich bin verloren',
    fr: 'Je suis perdu',
    cz: 'Jsem ztracený',
  },
  noMusic: {
    en: 'No music',
    it: 'Nessuna musica',
    es: 'Sin música',
    pl: 'Bez muzyki',
    de: 'Keine Musik',
    fr: 'Pas de musique',
    cz: 'Bez hudby',
  },
  enterStepField: {
    en: 'Enter the step where you left off',
    it: 'Inserite il passo in cui vi siete fermati',
    es: 'Introduzca el paso donde lo dejó',
    pl: 'Wprowadź krok, na którym skończyłeś',
    de: 'Gib den Schritt ein, bei dem du aufgehört hast',
    fr: `Entrez l'étape où vous vous êtes arrêté`,
    cz: 'Zadejte krok, kde jste přestali',
  },
  yourStep: {
    en: 'Your step:',
    it: 'Il tuo passo:',
    es: 'Tu paso:',
    pl: 'Twój krok:',
    de: 'Dein Schritt: ',
    fr: 'Votre étape:',
    cz: 'Váš krok:',
  },
  FAQTitle1: {
    en: `What is Let’s String?`,
    it: `Che cos'è Let's String?`,
    es: `¿Qué es Let's String?`,
    pl: `Czym jest Let's String?`,
    de: `Was ist Let's String?`,
    fr: `Qu'est-ce que Let's String?`,
    cz: `Co je Let's String?`,
  },
  FAQTitle2: {
    en: `I received the kit. What's next?`,
    it: `Ho ricevuto il kit. Cosa devo fare ora?`,
    es: `He recibido el kit. ¿Qué hago ahora?`,
    pl: `Otrzymałem zestaw. Co dalej?`,
    de: `Ich habe das Set erhalten. Was nun?`,
    fr: `J'ai reçu le kit. Et maintenant ?`,
    cz: `Obdržel jsem sadu. Co dál?`,
  },
  FAQTitle3: {
    en: `How can I change a threading speed or a background sound?`,
    it: `Come posso cambiare la velocità di infilatura o il suono di sottofondo?`,
    es: `¿Cómo puedo cambiar la velocidad de enhebrado o el sonido de fondo?`,
    pl: `Jak mogę zmienić prędkość nawlekania lub dźwięk w tle?`,
    de: `Wie kann ich die Fädelgeschwindigkeit oder den Hintergrundton ändern?`,
    fr: `Comment puis-je changer la vitesse de filage ou le son de fond?`,
    cz: `Jak mohu změnit rychlost navlékání nebo zvuk na pozadí?`,
  },
  FAQTitle4: {
    en: `What if I tangle?`,
    it: `E se mi aggroviglio?`,
    es: `¿Y si me enredo?`,
    pl: `Co zrobić, jeśli się pogubię?`,
    de: `Was, wenn ich mich verheddere?`,
    fr: `Et si je m'embrouille?`,
    cz: `Co když se ztratím v postupu?`,
  },
  FAQTitle5: {
    en: `How do I know how many steps I have left until Let'sString artwork is finished?`,
    it: `Come faccio a sapere quanti passi mi restano prima che l'opera d'arte Let'sString finisca?`,
    es: `¿Cómo sé cuántos pasos me faltan para terminar la obra de arte Let'sString?`,
    pl: `Jak się dowiedzieć ile kroków pozostało do zakończenia tworzenia mojego Let's String ?`,
    de: `Woher weiß ich, wie viele Schritte mir noch bis zur Fertigstellung des Let's String-Kunstwerks fehlen?`,
    fr: `Comment savoir combien d'étapes il me reste avant de terminer l'œuvre Let's String ?`,
    cz: `Jak zjistím, kolik kroků mi ještě zbývá do dokončení?`,
  },
  FAQTitle6: {
    en: `Which image to choose?`,
    it: `Quale immagine scegliere?`,
    es: `¿Qué imagen elegir?`,
    pl: `Który obraz wybrać?`,
    de: `Welches Bild soll ich wählen?`,
    fr: `Quelle image choisir ?`,
    cz: `Který obrázek si vybrat?`,
  },
  FAQTitle7: {
    en: `How do I upload an image?`,
    it: `Come faccio a caricare un'immagine?`,
    es: `¿Cómo subo una imagen?`,
    pl: `Jak przesłać zdjęcie?`,
    de: `Wie lade ich ein Bild hoch?`,
    fr: `Comment puis-je télécharger une image ?`,
    cz: `Jak nahraji obrázek?`,
  },
  FAQTitle8: {
    en: `What if the string breaks?`,
    it: `E se il filo si rompe?`,
    es: `¿Y si se rompe el cordel?`,
    pl: `Co jeśli sznurek pęknie?`,
    de: `Was, wenn der Faden reißt?`,
    fr: `Et si le fil se casse ?`,
    cz: `Co když se přetrhne nit?`,
  },
  FAQAnswer1: {
    en: `Let's String is a unique creativity kit that lets you turn any picture or photo into a stunning string painting. With easy-to-follow instructions and a helpful voice assistant, you can unleash your creativity and create a beautiful artwork. It's the perfect gift idea or a fun activity for yourself. Once finished, your Let's String masterpiece will become a captivating centerpiece in any room, drawing attention and adding elegance to your space.`,
    it: `Il kit di creatività Let's String è un modo unico per trasformare qualsiasi immagine o foto in un bellissimo quadro di spago. Con questo kit è possibile liberare la propria creatività e creare splendide opere d'arte. Le nostre istruzioni facili da seguire e l'assistente vocale vi guideranno attraverso il processo.
    Oltre a essere un'ottima idea regalo, questo kit è anche un'attività divertente per se stessi. Potete scegliere di regalarlo, ben incartato e pronto per essere assemblato, oppure potete assemblarlo voi stessi e presentarlo come un sentito regalo fatto a mano.
    Una volta terminato, il vostro quadro di corde aggiungerà un tocco di eleganza a qualsiasi interno. Preparatevi a stupire i vostri ospiti con questo capolavoro accattivante!`,
    es: `El kit de creatividad Let's String es una forma única de convertir cualquier imagen o foto en un bonito cuadro pintado con cuerdas. Con este kit, puedes dar rienda suelta a tu creatividad y crear obras de arte impresionantes. Nuestras instrucciones fáciles de seguir y el asistente de voz te guiarán durante todo el proceso.
    Además de ser una gran idea para regalar, este kit es también una divertida actividad para ti mismo. Puede optar por regalarlo, bellamente envuelto y listo para montar, o puede montarlo usted mismo y presentarlo como un sentido regalo hecho a mano.
    Una vez terminado, tu cuadro de cuerda añadirá un toque de elegancia a cualquier interior. Prepárate para impresionar a tus invitados con esta llamativa obra maestra.`,
    pl: `Zestaw kreatywny Let's String to wyjątkowy sposób na przekształcenie dowolnego obrazu lub zdjęcia w piękny obraz sznurkowy. Dzięki temu zestawowi możesz uwolnić swoją kreatywność i stworzyć wspaniałe dzieła sztuki. Nasze łatwe do wykonania instrukcje i asystent głosowy poprowadzą Cię przez cały proces.
    Oprócz tego, że jest to świetny pomysł na prezent, zestaw ten jest również świetną zabawą dla Ciebie. Możesz podarować go jako prezent, pięknie zapakowany i gotowy do złożenia, lub możesz złożyć go samodzielnie i podarować jako serdeczny, ręcznie robiony prezent.
    Po zakończeniu malowanie sznurkiem doda elegancji każdemu wnętrzu. Przygotuj się na zaimponowanie swoim gościom tym przyciągającym wzrok arcydziełem!
    `,
    de: `Let's String ist ein einzigartiges Kreativ-Set, mit dem du jedes Bild oder Foto in ein beeindruckendes Kunstwerk aus Fäden verwandeln kannst. Mit leicht verständlichen Anleitungen und einem hilfreichen Sprachassistenten kannst du deine Kreativität entfalten. Es ist ein perfektes Geschenk oder eine unterhaltsame Aktivität für dich selbst. Sobald dein Kunstwerk fertig ist, wird es zu einem echten Blickfang in jedem Raum.`,
    fr: `Let's String est un kit de créativité unique qui vous permet de transformer n'importe quelle image ou photo en une magnifique œuvre d'art avec du fil. Grâce à des instructions faciles à suivre et un assistant vocal utile, vous pouvez libérer votre créativité. C'est une excellente idée de cadeau ou une activité amusante pour soi-même. Une fois terminé, votre chef-d'œuvre Let's String deviendra un véritable centre d’attention dans n'importe quelle pièce.`,
    cz: `Let's String je jedinečná kreativní sada, která ti umožní proměnit jakýkoli obrázek nebo fotografii v úžasné umělecké dílo z nití. Díky snadno pochopitelným pokynům a užitečnému hlasovému průvodci můžeš popustit uzdu své kreativitě. Je to skvělý nápad na dárek nebo zábavná aktivita pro tebe samotného. Jakmile své dílo dokončíš, stane se poutavým prvkem každého prostoru.`,
  },
  FAQAnswer2: {
    en: `To get started, open the packages and locate the detaied paper manual enclosed. Take a moment to thoroughly read through the instructions. Afterward, visit our website and upload your photo.
    From there, you can select the assembly option that suits you best: either follow the online guide or download the PDF guide.`,
    it: `Per iniziare, aprire la confezione e trovare il manuale cartaceo allegato. Prendetevi un momento per leggere attentamente le istruzioni. Successivamente, visitate il nostro sito web e caricate la vostra foto.
    Da qui è possibile selezionare l'opzione di montaggio più adatta: seguire la guida online o scaricare la guida in PDF.`,
    es: `Para empezar, abre los paquetes y localiza el manual detallado en papel que se incluye. Tómese un momento para leer detenidamente las instrucciones. Después, visita nuestro sitio web y sube tu foto.
    A partir de ahí, puede seleccionar la opción de montaje que más le convenga: seguir la guía en línea o descargar la guía en PDF.`,
    pl: `Aby rozpocząć, otwórz opakowanie i znajdź załączoną szczegółową instrukcję. Poświęć chwilę na dokładne przeczytanie instrukcji. Następnie odwiedź naszą stronę internetową i prześlij swoje zdjęcie.
    Stamtąd możesz wybrać opcję montażu, która najbardziej Ci odpowiada: postępuj zgodnie z instrukcją online lub pobierz instrukcję PDF.`,
    de: `Öffne zunächst das Paket und suche das beiliegende gedruckte Handbuch. Lies dir die Anleitung sorgfältig durch. Danach besuche unsere Website und lade dein Foto hoch. Dort kannst du zwischen der Online-Anleitung oder dem PDF-Leitfaden wählen.`,
    fr: `Commencez par ouvrir l'emballage et repérez le manuel papier détaillé inclus. Prenez le temps de lire attentivement les instructions. Ensuite, visitez notre site web et téléchargez votre photo. Vous pouvez alors choisir l'option de montage qui vous convient le mieux : suivez le guide en ligne ou téléchargez le guide PDF.`,
    cz: `Nejprve otevři balení a najdi přiložený tištěný návod. Věnuj chvíli jeho pečlivému přečtení. Poté navštiv naše webové stránky a nahraj svou fotografii. Odtud si můžeš vybrat možnost sestavení, která ti nejvíce vyhovuje: sledovat online návod nebo stáhnout PDF průvodce.`,
  },
  FAQAnswer3: {
    en: `Our generator can be customised to suit your preferences. You have the freedom to select delightful background music or sound, a soothing voiceover, and adjust the assembling speed according to your liking. Faster speeds allow for quicker completion of your Let’sString artwork.`,
    it: `Il nostro generatore può essere personalizzato in base alle vostre preferenze. Avete la libertà di selezionare una musica o un suono di sottofondo piacevole, una voce fuori campo rilassante e di regolare la velocità di assemblaggio secondo i vostri gusti. Una velocità maggiore consente di completare più rapidamente la vostra opera d'arte Let'sString.`,
    es: `Nuestro generador puede personalizarse según sus preferencias. Tiene la libertad de seleccionar una música o un sonido de fondo encantadores, una voz en off relajante y ajustar la velocidad de montaje a su gusto. Las velocidades más rápidas permiten terminar antes tu obra de Let'sString.`,
    pl: `Nasz generator można dostosować do własnych preferencji. Masz swobodę wyboru zachwycającej muzyki lub dźwięku w tle, kojącego lektora i dostosowania prędkości montażu do swoich upodobań. Większa prędkość pozwala na szybsze ukończenie kompozycji Let'sString.`,
    de: `Unser Generator lässt sich ganz nach deinen Wünschen anpassen. Du kannst angenehme Hintergrundmusik oder -geräusche, eine beruhigende Stimme und die Geschwindigkeit der Montage frei wählen. Höhere Geschwindigkeiten ermöglichen eine schnellere Fertigstellung deines Kunstwerks.`,
    fr: `Notre générateur est personnalisable selon vos préférences. Vous pouvez choisir une musique ou un son de fond agréable, une voix apaisante, et régler la vitesse d'assemblage à votre convenance. Une vitesse plus rapide permet de terminer votre œuvre Let's String plus rapidement.`,
    cz: `Náš generátor lze přizpůsobit tvým preferencím. Můžeš si vybrat příjemnou hudbu nebo zvuk na pozadí, uklidňující hlas a upravit rychlost sestavování podle své chuti. Vyšší rychlosti umožňují rychlejší dokončení tvého Let's String díla.`,
  },
  FAQAnswer4: {
    en: `Don't worry! We've made it easy to find your way back to the step where you left off. Just enter the step number in the left corner, and the generator will guide you right back to it. Alternatively, you can tap on the nail you need directly from the main screen of the generator.`,
    it: `Non preoccupatevi! Abbiamo semplificato il percorso per tornare al punto in cui ci si è fermati. Basta inserire il numero del passo nell'angolo in sinistra e il generatore vi guiderà direttamente al passo. In alternativa, potete toccare l'unghia di cui avete bisogno direttamente dalla schermata principale del generatore.`,
    es: `No te preocupes. Te lo hemos puesto fácil para que encuentres el camino de vuelta al paso donde lo dejaste. Sólo tienes que introducir el número del paso en la esquina izquierda y el generador te guiará hasta él. También puedes pulsar sobre el clavo que necesites directamente desde la pantalla principal del generador.`,
    pl: `Nie martw się! Ułatwiliśmy powrót do kroku, w którym przerwałeś. Wystarczy wpisać numer kroku w lewym rogu, a generator poprowadzi Cię z powrotem do niego. Alternatywnie, możesz dotknąć potrzebnego gwoździa bezpośrednio z głównego ekranu generatora.`,
    de: `Keine Sorge! Du kannst ganz einfach zu dem Schritt zurückkehren, an dem du aufgehört hast. Gib einfach die Schrittzahl in die linke Ecke ein, und der Generator bringt dich direkt dorthin. Alternativ kannst du direkt auf den benötigten Nagel auf dem Hauptbildschirm tippen.`,
    fr: `Pas d’inquiétude ! Vous pouvez facilement revenir à l’étape où vous vous êtes arrêté. Il suffit d’entrer le numéro de l’étape dans le coin gauche, et le générateur vous y ramènera. Vous pouvez aussi appuyer directement sur le clou nécessaire depuis l’écran principal.`,
    cz: `Žádný strach! Jednoduše zadej číslo kroku do pravého rohu a generátor tě tam okamžitě vrátí. Případně můžeš kliknout přímo na potřebný hřebík na hlavní obrazovce generátoru.`,
  },
  FAQAnswer5: {
    en: `Below, you'll see a progress bar that indicates your current step and how much progress you've made so far.`,
    it: `Qui di seguito viene visualizzata una barra di avanzamento che indica il passo corrente e i progressi compiuti finora.`,
    es: `Abajo verás una barra de progreso que indica tu paso actual y cuánto has avanzado hasta ahora.`,
    pl: `W dolnej części generatora możesz zobaczyć, na jakim etapie obecnie się znajdujesz i ile kroków pozostało do ukończenia.`,
    de: `Unten siehst du eine Fortschrittsanzeige, die zeigt, an welchem Schritt du gerade bist und wie weit du bereits gekommen bist.`,
    fr: `En bas, une barre de progression vous indique votre étape actuelle et vos progrès réalisés jusqu'à présent.`,
    cz: `Dole uvidíš ukazatel postupu, který ti ukáže, na kterém kroku právě jsi a kolik jsi toho už dokončil.`,
  },
  FAQAnswer6: {
    en: `The best photo for a Let’sString art is a close-up of a single person with a contrast lighting.`,
    it: `La foto migliore per un'opera d'arte Let'sString è un primo piano di una singola persona con un'illuminazione contrastante.`,
    es: `La mejor foto para una ilustración de Let'sString es un primer plano de una sola persona con una iluminación de contraste.`,
    pl: `Najlepszym zdjęciem dla Let'sString jest zbliżenie jednej osoby z kontrastowym oświetleniem.`,
    de: `Das beste Foto für ein Let'sString-Kunstwerk ist eine Nahaufnahme einer einzelnen Person mit kontrastreicher Beleuchtung.`,
    fr: `La meilleure photo pour une œuvre Let'sString est un portrait rapproché d'une seule personne avec un éclairage contrasté.`,
    cz: `Nejvhodnější fotografie pro Let'sString je detailní záběr jedné osoby s kontrastním osvětlením.`,
  },
  FAQAnswer7: {
    en: `Use the instruction below
    1. Go to LetsString.art, or scan the QR code from the Unique Let's String code card
    2. Enter a unique 8-character Let'sString code from the card
    3. Upload your picture
    4. Select the design option
    5. Start assembling using the guides provided`,
    it: `Utilizzate le istruzioni riportate di seguito
    1. Andate su LetsString.art o scannerizzate il codice QR della cartolina con il codice unico Let's String.
    2. Inserite un codice Let'sString univoco di 8 caratteri dalla scheda.
    3. Caricate la vostra foto
    4. Selezionare l'opzione di design
    5. Iniziare l'assemblaggio utilizzando le guide fornite`,
    es: `Sigue estas instrucciones
    1. Vaya a LetsString.art, o escanee el código QR de la tarjeta de códigos Let's String única
    2. Introduce un código Let'sString único de 8 caracteres de la tarjeta
    3. Sube tu foto
    4. Selecciona la opción de diseño
    5. Empieza a montarlo siguiendo las guías`,
    pl: `Skorzystaj z poniższej instrukcji
    1. Wejdź na stronę LetsString.art lub zeskanuj kod QR z unikalnej karty kodów Let's String.
    2. Wprowadź unikalny 8-znakowy kod Let'sString z karty
    3. Prześlij swoje zdjęcie
    4. Wybierz opcję projektu
    5. Rozpocznij montaż, korzystając z dostarczonych instrukcji`,
    de: `Befolge diese Anleitung
    1. Besuche LetsString.art oder scanne den QR-Code von der Karte mit dem einzigartigen Let's String-Code
    2. Gib den 8-stelligen Let'sString-Code von der Karte ein
    3. Lade dein Bild hoch
    4. Wähle eine Designoption
    5. Beginne mit dem Zusammenbau anhand der bereitgestellten Anleitungen`,
    fr: `Suivez les instructions ci-dessous
    1. Rendez-vous sur LetsString.art ou scannez le code QR sur la carte avec le code unique Let's String
    2. Entrez le code unique de 8 caractères Let'sString figurant sur la carte
    3. Téléchargez votre photo
    4. Sélectionnez l’option de design
    5. Commencez l’assemblage en suivant les instructions fournies`,
    cz: `Postupuj podle tohoto návodu
    1. Přejdi na LetsString.art nebo naskenuj QR kód z karty s unikátním kódem Let's String
    2. Zadej jedinečný 8místný kód Let'sString z karty
    3. Nahraj svou fotografii
    4. Vyber si variantu designu
    5. Začni sestavovat podle poskytnutého návodu`,
  },
  FAQAnswer8: {
    en: `Don't worry - just tie a tight knot, cut off the excess and move on; it won't show on the finished artwork.`,
    it: `Non preoccupatevi: fate un nodo stretto, tagliate l'eccesso e andate avanti; non si vedrà sull'opera d'arte finita.`,
    es: `No te preocupes: haz un nudo apretado, corta el sobrante y sigue adelante; no se notará en la obra de arte terminada.`,
    pl: `Nie martw się-  Najpierw zawiąż węzeł na gwoździu, gdzie musiałeś się zatrzymać, i obetnij porwaną część. Następnie, używając nowej nici, zawiąż ją na tym samym gwoździu, aby kontynuować montaż swojego zestawu.  Nie będzie to widoczne na gotowej kompozycji.`,
    de: `Keine Sorge – mach einfach einen festen Knoten, schneide den überschüssigen Faden ab und mach weiter; im fertigen Kunstwerk wird es nicht sichtbar sein.`,
    fr: `Pas de panique – faites simplement un nœud serré, coupez l'excédent et continuez ; cela ne se verra pas sur l'œuvre terminée.`,
    cz: `Neboj se — stačí udělat pevný uzel, odstřihnout přebytek a pokračovat dál; na hotovém díle to nebude vidět.`,
  },
};
